// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17Vv8","expireSoon":"styles_expireSoon__2Qw9L"};